<agm-map [latitude]="lat" [zoom]="zoom" [longitude]="lng">
  <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
</agm-map>
